import merge from 'deepmerge'
import RedmineRoutes from './RedmineRoutes'

const routes = merge.all([RedmineRoutes])


export default routes;

